import { render, staticRenderFns } from "./ReservationDetail.vue?vue&type=template&id=24efa6a0&scoped=true"
import script from "./ReservationDetail.vue?vue&type=script&lang=js"
export * from "./ReservationDetail.vue?vue&type=script&lang=js"
import style0 from "./ReservationDetail.vue?vue&type=style&index=0&id=24efa6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24efa6a0",
  null
  
)

export default component.exports